import { BasicButton } from "./BasicButton";
import { DangerButton } from "./DangerButton";
import { FixedNavigationButton } from "./FixedNavigationButton";
import { GhostButton } from "./GhostButton";
import { PrimaryButton } from "./PrimaryButton";
import { SelectedButton } from "./SelectedButton";
import { WarningButton } from "./WarningButton";
import { ButtonSize, ButtonSizeValues } from "./types";

export const BUTTON_SIZES: Record<ButtonSize, ButtonSizeValues> = {
  small: {
    paddingHorizontal: "var(--space-3)",
    paddingVertical: "var(--space-2)",
    paddingIcon: "var(--space-2-5)",
    minSize: "space-8",
    iconSize: "space-4",
    textStyle: "global/button-small",
  },
  medium: {
    paddingHorizontal: "var(--space-4)",
    paddingVertical: "var(--space-2-5)",
    paddingIcon: "var(--space-3)",
    minSize: "space-10",
    iconSize: "space-4",
    textStyle: "global/button-medium",
  },
  large: {
    paddingHorizontal: "var(--space-6)",
    paddingVertical: "var(--space-3)",
    paddingIcon: "var(--space-5)",
    minSize: "space-12",
    iconSize: "space-5",
    textStyle: "global/button-large",
  },
} as const;

export const ICON_BUTTON_SIZES = {
  small: {
    iconSize: "space-5",
    buttonSize: "space-8",
  },
  medium: {
    iconSize: "space-6",
    buttonSize: "space-10",
  },
  large: {
    iconSize: "space-8",
    buttonSize: "space-12",
  },
} as const;

export const buttons = [
  PrimaryButton,
  SelectedButton,
  DangerButton,
  WarningButton,
  GhostButton,
  BasicButton,
  FixedNavigationButton,
];
